import "~/src/global"
import "~/src/polyfills"

import collapse from "@alpinejs/collapse"
import intersect from "@alpinejs/intersect"
import persist from "@alpinejs/persist"
import Alpine from "alpinejs"

import clipboard from "~/src/alpine/clipboard"
import { adminNav } from "~/src/alpine/components/adminNav"
import { photoGallery } from "~/src/alpine/components/photoGallery"
import hashRouter from "~/src/alpine/hashRouter"
import { initModalStore } from "~/src/alpine/modalStore"
import { initSidebarStore } from "~/src/alpine/sidebarStore"
import { defineTiltDirective } from "~/src/alpine/tiltDirective"
import { defineTipDirective } from "~/src/alpine/tipDirective"

window.Alpine = Alpine

// Load plugins
window.Alpine.plugin(persist)
window.Alpine.plugin(collapse)
window.Alpine.plugin(intersect)
window.Alpine.plugin(clipboard)
window.Alpine.plugin(hashRouter)

// Load components
adminNav(window.Alpine)
initSidebarStore(window.Alpine)
initModalStore(window.Alpine)
defineTipDirective(window.Alpine)
defineTiltDirective(window.Alpine)
photoGallery(window.Alpine)

window.Alpine.start()
